import React from "react";

const Navbar = ({ children, onMouseLeave }) => (
  <nav className="m-auto" onMouseLeave={onMouseLeave}>
    <ul className="flex justify-center list-none m-0">{children}</ul>
  </nav>
)

export default Navbar;
